exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[dir] .prompt_tapEditorPrompt__3r-5K .ant-form-item-has-error input{background-color:#fff;border-color:#ff4d4f}.prompt_tapEditorFooter__35nVQ{display:flex;justify-content:flex-end}[dir=ltr] .prompt_cancelButton__34GF8{margin-left:1.5rem}[dir=rtl] .prompt_cancelButton__34GF8{margin-right:1.5rem}", ""]);

// Exports
exports.locals = {
	"tapEditorPrompt": "prompt_tapEditorPrompt__3r-5K",
	"tapEditorFooter": "prompt_tapEditorFooter__35nVQ",
	"cancelButton": "prompt_cancelButton__34GF8"
};